import { formatCopy } from '../copy/format.js';
import copy from '../copy/en/signing.json' with { type: 'json' };
/** Display server guidance; callers retain state and only retry on user action. */
export function signingRetryGuidance(response: Response, fallback: string): string {
  if (response.status !== 429 && response.status !== 503) return fallback;
  const raw = response.headers.get("Retry-After") ?? "";
  const seconds = /^\d+$/.test(raw) ? Math.min(300, Math.max(1, Number(raw))) : 5;
  return formatCopy(copy.retryAfter, { message: fallback, seconds });
}
